const firebaseConfig = {
  apiKey: "AIzaSyDfUhPgOYqqBr1g8l_zw49pGb-eL6FTygs",
  authDomain: "holidayzplan.firebaseapp.com",
  projectId: "holidayzplan",
  storageBucket: "holidayzplan.appspot.com",
  messagingSenderId: "855138360937",
  appId: "1:855138360937:web:2c75cbe83b62553b5a4cf8"
};
export default firebaseConfig;